import React, { useState } from "react";
import { ArrowRightIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";

const cards = [
  {
    id: 1,
    title: "Goa, India",
    subtitle: `Goa is a perfect mix of relaxing beaches, lively culture, and scenic beauty. From sun-soaked shores to vibrant markets and delicious food, it’s an ideal getaway for both relaxation and fun.`,
    image:
      "https://plus.unsplash.com/premium_photo-1697729701846-e34563b06d47?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0",
  },
  {
    id: 2,
    title: "Sikkim, India",
    subtitle: `Snow-capped peaks and peaceful valleys create a magical mountain escape.`,
    image:
      "https://images.unsplash.com/photo-1633323773493-1e1e04780167?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0",
  },
  {
    id: 3,
    title: "Maldives",
    subtitle: `Turquoise waters and pristine beaches.`,
    image:
      "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?q=80&w=1965&auto=format&fit=crop&ixlib=rb-4.1.0",
  },
  {
    id: 4,
    title: "Switzerland",
    subtitle: `World-famous landmarks and charming cafés.`,
    image:
      "https://images.unsplash.com/photo-1594069758873-e79e9075eb7d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0",
  },
];

const HoverCard = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Detect screen width to apply hover only on md+ screens
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isHoverEnabled = windowWidth >= 768;

  return (
    <div className="flex gap-4 overflow-x-auto">
      {cards.map((card, index) => {
        const isHovered = hoveredIndex === index;
        const isDefault = hoveredIndex === null && index === 0;

        // Determine flexGrow based on hover & screen size
        const flexGrowValue = isHoverEnabled
          ? isHovered || isDefault
            ? 2
            : 1
          : 1;

        return (
          <div
            key={card.id}
            onMouseEnter={() => isHoverEnabled && setHoveredIndex(index)}
            onMouseLeave={() => isHoverEnabled && setHoveredIndex(null)}
            className={`min-w-[350px] max-w-[700px] flex-shrink-0 cursor-pointer rounded-2xl transition-all
              duration-500 ease-in-out sm:min-w-[350px] sm:max-w-[700px] 
              md:min-w-[350px] md:max-w-[700px] lg:max-w-[70%]`}
            style={{ flexGrow: flexGrowValue, flexBasis: 0 }}
          >
            <div
              className="relative flex h-[500px] w-full flex-col justify-end rounded-2xl bg-cover bg-center p-6 text-white"
              style={{ backgroundImage: `url(${card.image})` }}
            >
              <div className="rounded-xl bg-opacity-40 p-4 backdrop-blur-sm">
                <h2 className="text-xl font-bold md:text-3xl">{card.title}</h2>
                <p className="mt-2 text-sm md:text-lg">{card.subtitle}</p>
                <Link to="/hotels">
                  <button className="mt-4 flex w-full items-center justify-between rounded-full bg-white px-4 py-2 font-medium text-black transition-colors hover:bg-gray-200">
                    View Hotels
                    <ArrowRightIcon className="ml-2 h-5 w-5" />
                  </button>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HoverCard;
